import { createSelector } from 'reselect';


const getHotkeyTmpState = createSelector(
  [
    (state) => state.hotkey_template
  ],
  (state) => state
);


const getHotkeyTmpModalState = createSelector(
  [
    getHotkeyTmpState
  ],
  (state) => state.modal
);


export const getAddModalState = createSelector(
  [
    getHotkeyTmpModalState
  ],
  (modal) => modal.add
);


export const getEditModalState = createSelector(
  [
    getHotkeyTmpModalState
  ],
  (modal) => modal.edit
);

